import { useEffect, useState } from 'react';
import { Service } from '../api-objects/Service';
import { Register } from '../api-objects/Register';

const RegisterService = () => {
  const [result, setResult] = useState<Service<Register>>({
    status: 'loading'
  });

  useEffect(() => {
    fetch('/api/register.json')
      .then(response => response.json())
      .then(response => setResult({ status: 'loaded', payload: response }))
      .catch(error => setResult({ status: 'error', error }));
  }, []);

  return result;
};

export default RegisterService;